import { z } from 'zod'

export const WithSubscriberCountEstimateSchema = z.object({
  subscriberCount: z.number().int().nonnegative(),
  subscriberCountEstimatedAt: z.date(),
})

export type WithSubscriberCountEstimate = z.infer<typeof WithSubscriberCountEstimateSchema>
